module.exports = __webpack_public_path__ + "img/00006.3b3123c5.webp";